export const USER_ACTIONS = {
  LIKE_VIDEO: "like-video",
  PLAYLIST_VIDEO: "playlist-video",
  WATCH_LATER_VIDEO: "watch-later-video",
  COPY_LINK_VIDEO: "copy-link-video",
  ADD_TO_HISTORY: "add-to-history",
  REMOVE_FROM_HISTORY: "remove-from-history",
};
